var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "line_chart", attrs: { id: "qpe_line_chart" } }, [
    _c("div", { style: { "text-align": "center" }, attrs: { id: _vm.id } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }